import React, { useState, useEffect, useContext } from "react";
import { Users, GraduationCap, Building2 } from "lucide-react";
import axios from "axios";

import "../../../assests/css/admin/AdminDashboard.css";
import Adminmasterlayout from "../../../layouts/Adminmasterlayout/Adminmasterlayout";
import AdminNotificationBell from "../../../components/admin/AdminNotificationBell/AdminNotificationBell";
import { AppContext } from "../../../context/Appcontext";


const AdminDashboard = () => {
  const { baseUrl } = useContext(AppContext);

const [dashboard, setDashboard] = useState({
  students: 0,
  teachers: 0,
  departments: 0,
});
  const [activeTab, setActiveTab] = useState('overview');
  // Mock data for statistics
const stats = [
  {
    id: 1,
    title: "Total Students",
    value: dashboard.students,
    icon: Users,
    color: "#6A88CE",
  },
  {
    id: 2,
    title: "Total Teachers",
    value: dashboard.teachers,
    icon: GraduationCap,
    color: "#E4916D",
  },
  {
    id: 3,
    title: "Total Departments",
    value: dashboard.departments,
    icon: Building2,
    color: "#8B5CF6",
  },
];

  // Mock data for attendance chart
  // const attendanceData = [
  //   { month: 'Jan', rate: 85 },
  //   { month: 'Feb', rate: 88 },
  //   { month: 'Mar', rate: 82 },
  //   { month: 'Apr', rate: 90 },
  //   { month: 'May', rate: 87 },
  //   { month: 'Jun', rate: 92 },
  //   { month: 'Jul', rate: 89 },
  //   { month: 'Aug', rate: 91 },
  //   { month: 'Sep', rate: 88 },
  //   { month: 'Oct', rate: 93 },
  //   { month: 'Nov', rate: 90 },
  //   { month: 'Dec', rate: 94 }
  // ];

  // Mock data for enrollment trends
  // const enrollmentData = [
  //   { month: 'Jan', students: 220 },
  //   { month: 'Feb', students: 180 },
  //   { month: 'Mar', students: 250 },
  //   { month: 'Apr', students: 200 },
  //   { month: 'May', students: 280 },
  //   { month: 'Jun', students: 320 },
  //   { month: 'Jul', students: 290 },
  //   { month: 'Aug', students: 380 },
  //   { month: 'Sep', students: 420 },
  //   { month: 'Oct', students: 360 },
  //   { month: 'Nov', students: 310 },
  //   { month: 'Dec', students: 340 }
  // ];

  // Recent activities with more structured data
  // const recentActivities = [
  //   { 
  //     id: 1, 
  //     title: 'NEW Student Enrollment', 
  //     description: 'Sarah Johnson enrolled in Computer Science', 
  //     date: '2024-02-17',
  //     time: '2 hours ago', 
  //     type: 'enrollment',
  //     status: 'Completed'
  //   },
  //   { 
  //     id: 2, 
  //     title: 'Course Added', 
  //     description: 'Advanced React Development course created', 
  //     date: '2024-02-17',
  //     time: '4 hours ago', 
  //     type: 'course',
  //     status: 'Active'
  //   },
  //   { 
  //     id: 3, 
  //     title: 'Exam Schedule Updated', 
  //     description: 'Grade 10 - Mathematics exam rescheduled', 
  //     date: '2024-02-17',
  //     time: '6 hours ago', 
  //     type: 'exam',
  //     status: 'Pending'
  //   },
  //   { 
  //     id: 4, 
  //     title: 'Teacher Assignment', 
  //     description: 'Dr. Emily Brown assigned to Physics Department', 
  //     date: '2024-02-16',
  //     time: '1 day ago', 
  //     type: 'teacher',
  //     status: 'Completed'
  //   },
  //   { 
  //     id: 5, 
  //     title: 'Department Created', 
  //     description: 'New Artificial Intelligence department established', 
  //     date: '2024-02-16',
  //     time: '1 day ago', 
  //     type: 'department',
  //     status: 'Active'
  //   },
  //   { 
  //     id: 6, 
  //     title: 'Attendance Report', 
  //     description: 'Monthly attendance report generated', 
  //     date: '2024-02-15',
  //     time: '2 days ago', 
  //     type: 'report',
  //     status: 'Completed'
  //   }
  // ];

  // const maxAttendance = Math.max(...attendanceData.map(d => d.rate));
  // const maxEnrollment = Math.max(...enrollmentData.map(d => d.students));
useEffect(() => {
  fetchDashboard();
}, []);

const fetchDashboard = async () => {
  try {
    const res = await axios.get(`${baseUrl}/admin/dashboard`);

    setDashboard({
      students: res.data.students,
      teachers: res.data.teachers,
      departments: res.data.departments,
    });
  } catch (error) {
    console.log(error);
  }
};
  return (
    <Adminmasterlayout>
      <div className="adm-dashboard">
        <div className="adm-dashboard__container">
          <div className="adm-dashboard__header">
            <div className="adm-dashboard__header-content">
              <h1 className="adm-dashboard__title">Dashboard Overview</h1>
              <p className="adm-dashboard__subtitle">
                Welcome back! Here's what's happening with your institution today.
              </p>
            </div>
            <div className="adm-dashboard__header-actions">
              <select className="adm-dashboard__date-selector">
                <option>Last 30 days</option>
                <option>Last 7 days</option>
                <option>Last 90 days</option>
                <option>This year</option>
              </select>
              <AdminNotificationBell />
            </div>
          </div>

         <div className="adm-dashboard__stats-grid">
  {stats.map((stat) => {
    const Icon = stat.icon;

    return (
      <div key={stat.id} className="adm-stat-card">
        <div className="adm-stat-card__header">
          <div
            className="adm-stat-card__icon"
            style={{ backgroundColor: `${stat.color}15` }}
          >
            <Icon size={24} color={stat.color} />
          </div>
        </div>

        <div className="adm-stat-card__body">
          <h3 className="adm-stat-card__value">{stat.value}</h3>
          <p className="adm-stat-card__title">{stat.title}</p>
        </div>
      </div>
    );
  })}
</div>

          <div className="adm-dashboard__charts-grid">
            {/* Attendance Chart */}
            {/* <div className="adm-chart-card">
              <div className="adm-chart-card__header">
                <h2 className="adm-chart-card__title">Attendance Rate</h2>
                <span className="adm-chart-card__subtitle">Monthly attendance percentage</span>
              </div>
              <div className="adm-chart-card__content">
                <div className="adm-bar-chart">
                  {attendanceData.map((item, index) => (
                    <div key={index} className="adm-bar-chart__group">
                      <div className="adm-bar-chart__wrapper">
                        <div 
                          className="adm-bar-chart__bar adm-bar-chart__bar--attendance"
                          style={{ height: `${(item.rate / maxAttendance) * 100}%` }}
                        >
                          <span className="adm-bar-chart__tooltip">{item.rate}%</span>
                        </div>
                      </div>
                      <span className="adm-bar-chart__label">{item.month}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div> */}

            {/* Enrollment Chart */}
            {/* <div className="adm-chart-card">
              <div className="adm-chart-card__header">
                <h2 className="adm-chart-card__title">Student Enrollment</h2>
                <span className="adm-chart-card__subtitle">New enrollments per month</span>
              </div>
              <div className="adm-chart-card__content">
                <div className="adm-bar-chart">
                  {enrollmentData.map((item, index) => (
                    <div key={index} className="adm-bar-chart__group">
                      <div className="adm-bar-chart__wrapper">
                        <div 
                          className="adm-bar-chart__bar adm-bar-chart__bar--enrollment"
                          style={{ height: `${(item.students / maxEnrollment) * 100}%` }}
                        >
                          <span className="adm-bar-chart__tooltip">{item.students}</span>
                        </div>
                      </div>
                      <span className="adm-bar-chart__label">{item.month}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div> */}
          </div>

          {/* Recent Activities - Updated Design */}
          {/* <div className="adm-activities">
            <div className="adm-activities__header">
              <h2 className="adm-activities__title">Recent Activities</h2>
              <button className="adm-activities__view-all">View All</button>
            </div>
            
            <div className="adm-activities__table-container">
              <table className="adm-activities__table">
                <thead className="adm-activities__table-head">
                  <tr className="adm-activities__table-row">
                    <th className="adm-activities__table-header">Activity Type</th>
                    <th className="adm-activities__table-header">Details</th>
                    <th className="adm-activities__table-header">Date</th>
                    <th className="adm-activities__table-header">Time</th>
                    <th className="adm-activities__table-header">Status</th>
                  </tr>
                </thead>
                <tbody className="adm-activities__table-body">
                  {recentActivities.map((activity) => (
                    <tr key={activity.id} className="adm-activities__table-row">
                      <td className="adm-activities__table-cell" data-label="Activity Type">
                        <div className="adm-activities__type">
                          <div className={`adm-activities__icon adm-activities__icon--${activity.type}`}>
                            {activity.type === 'enrollment' && <Users size={18} />}
                            {activity.type === 'course' && <BookOpen size={18} />}
                            {activity.type === 'exam' && <FileText size={18} />}
                            {activity.type === 'teacher' && <GraduationCap size={18} />}
                            {activity.type === 'department' && <Users size={18} />}
                            {activity.type === 'report' && <FileText size={18} />}
                          </div>
                          <span className="adm-activities__type-text">{activity.title}</span>
                        </div>
                      </td>
                      <td className="adm-activities__table-cell adm-activities__table-cell--description" data-label="Details">
                        {activity.description}
                      </td>
                      <td className="adm-activities__table-cell" data-label="Date">
                        {activity.date}
                      </td>
                      <td className="adm-activities__table-cell" data-label="Time">
                        <div className="adm-activities__time">
                          <Clock size={14} />
                          <span>{activity.time}</span>
                        </div>
                      </td>
                      <td className="adm-activities__table-cell" data-label="Status">
                        <span className={`adm-activities__status adm-activities__status--${activity.status.toLowerCase()}`}>
                          {activity.status === 'Completed' && <CheckCircle size={14} />}
                          {activity.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div> */}
        </div>
      </div>
    </Adminmasterlayout>
  );
};

export default AdminDashboard;